var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layer", { staticClass: "opt_more_g", attrs: { name: "role" } }, [
    _c(
      "div",
      { staticClass: "box_opt_menu opt_menu_grade" },
      _vm._l(_vm.roles, function(ref) {
        var code = ref.code
        var name = ref.name
        return _c("div", { staticClass: "menu_item" }, [
          _c(
            "a",
            {
              staticClass: "link_menu",
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.callback(code)
                }
              }
            },
            [_vm._v(_vm._s(name))]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }